import { render, staticRenderFns } from "./PanelFooter.vue?vue&type=template&id=7792e9bc&"
import script from "./PanelFooter.vue?vue&type=script&lang=js&"
export * from "./PanelFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports